import { IWorkspaceResourceFolder, IWorkspaceResourceBase, WorkspaceResourceType } from "common/interfaces";

import WorkspaceController from "js/controllers/WorkspaceController";
import getLogger, { LogGroup } from "js/core/logger";
import withProgressDialog from "js/core/utilities/withProgressDialog";
import { ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";

const logger = getLogger(LogGroup.TEAMS);

export type FolderDropResource = {
    resourceId: string;
    resourceType: WorkspaceResourceType;
};

/** Folder moves use workspace resourceId (not the resource record id). */
export function folderDropResourceFromWorkspaceResource(
    resource: Pick<IWorkspaceResourceBase, "resourceId" | "resourceType">
): FolderDropResource {
    return {
        resourceId: resource.resourceId,
        resourceType: resource.resourceType,
    };
}

type MoveResourcesToFolderOptions = {
    folder: IWorkspaceResourceFolder;
    resources: FolderDropResource[];
    progressTitle: string;
    progressTitlePlural: (count: number) => string;
    errorMessage: string;
    logTag: string;
};

export async function moveResourcesToFolder({
    folder,
    resources,
    progressTitle,
    progressTitlePlural,
    errorMessage,
    logTag,
}: MoveResourcesToFolderOptions) {
    try {
        await withProgressDialog({
            title: resources.length === 1 ? progressTitle : progressTitlePlural(resources.length),
            action: () =>
                WorkspaceController.updateWorkspaceResourceFolderResources({
                    folderId: folder.id,
                    update: {
                        add: resources.map(resource => ({
                            ...resource,
                            permissions: {
                                read: { object: true, permissions: true },
                                write: { object: false, permissions: false },
                            },
                        })),
                    },
                })
        });
    } catch (err) {
        logger.error(err, `[${logTag}] moveResourcesToFolder failed`, { folderId: folder.id });

        ShowErrorDialog({
            error: errorMessage,
            message: (err as Error).message,
        });
    }
}
